export function bbox2zoom (bbox) {
  const latDiff = bbox[3] - bbox[1]
  const lngDiff = bbox[2] - bbox[0]
  const maxDiff = (lngDiff > latDiff) ? lngDiff : latDiff
  let zoomLevel
  if (maxDiff < 360 / Math.pow(2, 20)) {
    zoomLevel = 21
  } else {
    zoomLevel = -1 * ((Math.log(maxDiff) / Math.log(2)) - (Math.log(360) / Math.log(2)))
    if (zoomLevel < 1) zoomLevel = 1
  }
  return zoomLevel
}

export const colors = ['#2196F3', '#E91E63', '#7E57C2', '#009688', '#00BCD4', '#EF6C00', '#4CAF50', '#FF9800', '#F44336', '#CDDC39', '#9C27B0', '#FFC107', '#3F51B5', '#795548', '#607D8B', '#FF9800', '#03A9F4', '#8BC34A', '#FFEB3B']
